export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function createCheckout(originUrl) {
  const res = await fetch(`${API}/payments/checkout`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      lookup_key: "trustmaster_licenza_una_tantum",
      origin_url: originUrl,
    }),
  });
  if (!res.ok) throw new Error("checkout_failed");
  return res.json();
}

export async function getPaymentStatus(sessionId) {
  const res = await fetch(`${API}/payments/status/${sessionId}`);
  if (!res.ok) throw new Error("status_failed");
  return res.json();
}

export async function submitContact(payload) {
  const res = await fetch(`${API}/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("contact_failed");
  return res.json();
}
